import React from "react";
import {Switch, Route} from "react-router-dom";

import Logout from "components/LM/Bsso/Logout";

const LogoutConnect = () => (
	<Switch>
		<Route path="/bsso/logout">
			<Logout></Logout>
		</Route>
	</Switch>
)

export default LogoutConnect;
